<template>
    <v-container>
        <v-row v-if="status === 'created'">
            <h3>Your account was successfully created and is now pending approval</h3>
        </v-row>
        <v-row v-if="status === 'verrified'">
            <h3>You're successfully verrified.</h3>
        </v-row>
        <v-row v-if="status.length < 1"> 
            <v-col>
                <div class="bd-form" v-html="form">
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'LoginRegister',
        data() {
            return {
                form: '',
                status: this.$route.query.status !== undefined ? this.$route.query.status : ''
            }
        },
        mounted() {

            // this.$axios.get(this.$store.state.client_vars.LOGINFORM)
            //     .then(response => {
            //         this.form = response.data
            //         this.loading = false
            //     })
            //     .catch(error => console.log('Failed to return form', error))

            this.$axios({
                url: this.$store.state.client_vars.LOGINFORM,
                responseType: 'document'
            })
            .then(response => {
                this.form = response.data.body.innerHTML
                this.loading = false
                this.setInterval()
            })
            .then(() => {
                let js = document.querySelectorAll('form script');
                for(let i = 0; i < js.length; i++) {
                    eval(js[i].text)
                }
            })
            .catch(error => console.log('Failed to return form', error))

        },
        methods: {
            bindToLogin: () => {
                let submit = document.querySelector('#SQ_LOGIN_SUBMIT');
                let pwd = document.querySelector('#SQ_LOGIN_PASSWORD');
                let user = document.querySelector('#SQ_LOGIN_USERNAME');

                
                pwd.addEventListener('keydown', (e) => {
                    if(e.keyCode === 13 || e.key === "Enter") {
                        console.log('pressed enter on login')
                        submit.click();
                    }
                })

                user.addEventListener('keydown', (e) => {
                    if(e.keyCode === 13 || e.key === "Enter") {
                        console.log('pressed enter on login')
                        submit.click();
                    }
                })
            },
            setInterval: function() {
                // wait for form to appear before binding events to it
                let interval = window.setInterval(() => {
                    if(document.querySelector('form').length > 0) {
                        clearInterval(interval)
                        this.bindToLogin();
                        this.bindForm(this.form)
                    } else {
                        console.log('finding....')
                    }
                }, 500)
            },
            bindForm: function(form) {
                document.querySelector('form').addEventListener('submit', (e) => {
                    e.preventDefault();
                    
                    this.postForm(e.target)
                })
            },
            postForm: function(form) {
                this.form = "Loading"
                let url = form.getAttribute('action');

                this.$axios({
                    method: 'post',
                    url: url,
                    data: new FormData(event.target),
                    responseType: 'document'
                    // headers: {'Content-Type': 'multipart/form-data' },
                })
                .then((response) => {
                    this.form = response.data.body.innerHTML
                    this.setInterval()
                    this.$axios.get(this.$store.state.client_vars.MENU)
                    .then(response => {
                        this.$store.commit('addMenu', response.data)
                    })
                    .catch(error => console.log('Failed to get menu', error))
                })
                .then(() => {
                    let js = document.querySelectorAll('form script');
                    for(let i = 0; i < js.length; i++) {
                        eval(js[i].text)
                    }
                })
                event.preventDefault();
            },
        }
    }
</script>

<style lang="scss">
.bd-form {

    .bd-form__account-manager {
        display: flex;

        @media all and (max-width: 960px) {
            display: initial;
        }

        input[type="submit"], input[type="button"] {
            margin-top: 20px;
        }


        input[type="password"] {
            margin-bottom: 4px;
        }

        .bd-form__text {
            p {
                color: #53565a;
            }
        }
    }
    

    .bd-form__register {
        position: relative;

        &:after {
            content: "";
            position: absolute;
            right: -6%;
            top: 0;
            bottom: 0;
            width: 1px;
            background-color:#ececec;
            box-shadow: 0px 0px 1px 0px #ececec;

            @media all and (max-width: 960px) {
                content: none;
            }
        }
    }

    table {
        width: 100%;

        &.sq-backend-section-table > tbody > tr > td {
            margin-top: 0;
        }
    }
    .sq-backend-section-table-inner {
        tr {
            &:nth-last-child(-n+2) {
                display: none;
            }
        }
    }

    td {
        display: inline;

        &:first-of-type {
            color: #53565a;
            font-size: 14px;
            margin-top: 20px;
            margin-bottom: 5px;
            display: block;
        }

        .bd-form__text {
            p {
                color: #53565a;
            }

            &--create {

            }
        }
        
        &.sq-limbo-section-heading {
            display: none;
        }

        .sq-backend-smallprint  {
            font-size: 13px;
            margin-bottom: 10px;
        }
    }
}
</style>